import { Button, VText } from '@vake/ui-kit';
import { Feature, GeoJsonProperties } from 'geojson';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { vake_api_server_url } from '../requests/helpers';
import { useInsightByUuid } from '../requests/insights';
import { DetectionImage } from '../shared/components/Popup';
import { InputFieldTW } from '../shared/styles/InputFields';
import { checkIfValidUUID } from '../utils/validation';

const Candidate: React.FC<{
    index: number;
    properties: GeoJsonProperties;
    // uuid: string;
    // timestamp: Date;
    // imagePath: string;
    activated: boolean | null;
    clickedCandidates: number[];
    setClickedCandidates: Dispatch<SetStateAction<number[]>>;
    // }> = ({ index, uuid, timestamp, imagePath, activated, clickedCandidates, setClickedCandidates }) => {
}> = ({ index, properties, activated, clickedCandidates, setClickedCandidates }) => {
    const {
        uuid,
        // image_source,
        timestamp,
        // correlated,
        // object_class,
        // matching_label,
        length,
        lon,
        lat,
        // object_class_score,
        // ais_length,
        // estimation_score,
        // matching_score,
        course,
        speed,
        mmsi,
        image_path,
        // distance_to_mmsi,
        // ais_length,
        // time_to_nearest_ais,
    } = properties;

    const formattedTimestamp = new Date(timestamp).toUTCString();

    const onClickCandidate = () => {
        if (!clickedCandidates.includes(index)) {
            setClickedCandidates([...clickedCandidates, index]);
        }
    };

    const handleRemoveClick = (index: number) => {
        setClickedCandidates(clickedCandidates.filter((number: number) => number !== index));
    };

    return (
        <div className="flex w-34 bg-background-secondary" key={index} onClick={() => onClickCandidate()}>
            <DetectionImage image_path={image_path} />
            <div>
                {formattedTimestamp && <VText>Timestamp: {formattedTimestamp}</VText>}
                {uuid && <VText>UUID: {uuid}</VText>}
                {lon && <VText>Longitude: {lon}</VText>}
                {lat && <VText>Latitude: {lat}</VText>}
                {length && <VText>Length: {length}</VText>}
                {course && <VText>Course: {course}</VText>}
                {speed && <VText>Speed: {speed}</VText>}
                {mmsi && <VText>MMSI: {mmsi}</VText>}
                {/* <div>{activated ? uuid : 'Click for UUID'}</div> */}
                {activated && <Button onClick={() => handleRemoveClick(index)} text="Remove this"></Button>}
            </div>
        </div>
    );
};

const VisualizeCandidates: FC = () => {
    useEffect(() => {
        document.title = 'Candidates';
    }, []);

    const [findThisBoat, setFindThisBoat] = useState<string | null>(null);
    const [couldBeTheseBoats, setCouldBeTheseBoats] = useState<string[] | null>(null);

    const { data: insights } = useInsightByUuid(couldBeTheseBoats);

    const [clickedCandidates, setClickedCandidates] = useState<number[]>([]);

    const handleFindThisChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const noSpace = event.target.value.replace(/\s+/g, '');
        const newElement = noSpace.replaceAll("'", '"').replaceAll('"', '');
        setFindThisBoat(newElement);
    };

    const handleCouldBeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const noSpace = event.target.value.replace(/\s+/g, '');
        const elements = noSpace.split(',');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const cand = elements.reduce((elements, item: any) => {
            const newElement = item
                .replaceAll("'", '"') // replace all single quote with double quote
                .replaceAll('"', '') // replace all double quote with blank
                .replace('[', '')
                .replace(']', '')
                .replace(';', '');
            if (checkIfValidUUID(newElement)) {
                elements.push(newElement);
            }
            return elements;
        }, []);
        setCouldBeTheseBoats(cand);
    };

    return (
        <div className="flex items-center justify-center h-screen w-fill gap-2">
            <div className="flex items-center content-center bg-background-tertiary rounded p-4">
                <div>
                    <VText>Ship to find</VText>
                    <VText>Example: 738c8c72-bd9a-4f3a-8628-e43b825844e1</VText>

                    <InputFieldTW
                        type="text"
                        onChange={handleFindThisChange}
                        value={findThisBoat ? findThisBoat : ''}
                    />
                </div>
                {findThisBoat && (
                    <DetectionImage image_path={`${vake_api_server_url}/insights/image/uuid/${findThisBoat}`} />
                )}
            </div>
            {insights ? (
                <div>
                    {insights.features.map((feature: Feature, index: number) => {
                        const insight = feature.properties;
                        const uuid = insight!.uuid;
                        if (uuid && uuid.length > 10) {
                            return (
                                <Candidate
                                    key={index}
                                    index={index}
                                    properties={insight}
                                    activated={clickedCandidates.includes(index)}
                                    clickedCandidates={clickedCandidates}
                                    setClickedCandidates={setClickedCandidates}
                                />
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
            ) : (
                <div className="flex items-center content-center bg-background-tertiary rounded p-4">
                    <div>
                        <VText> List of potential candidates </VText>
                        <InputFieldTW
                            type="text"
                            onChange={handleCouldBeChange}
                            value={couldBeTheseBoats ? couldBeTheseBoats : ''}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default VisualizeCandidates;
